export default __webpack_public_path__ + "static/media/testimonial-1.dc7a67a8.jpg";